import React, { useCallback, useRef } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { ShipmentCost } from "../../Models/ShipmentCost";
import { useListProps } from "./utilities/list";
import { useParams } from "react-router-dom";
import { ShipmentCostsListItem } from "./ShipmentCostsListItem";
import { ShipmentCostFooter } from "./ShipmentCostsFooter";
import { ShipmentCostHeader } from "./ShipmentCostsHeader";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const Index: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const { id } = useParams<{ id: string }>();
  const listProps = useListProps(id);
  const renderHeader = useCallback(() => {
    return <ShipmentCostHeader />;
  }, []);
  const renderItem = useCallback((item: ShipmentCost, index: number) => {
    return (
      <ShipmentCostsListItem listRef={listRef} item={item} index={index} />
    );
  }, []);
  const renderFooter = useCallback(() => {
    return <ShipmentCostFooter />;
  }, []);

  return (
    <>
      <AnyListProvider path={listProps.path} filters={listProps.filters}>
        <AnyList
          renderHeader={renderHeader}
          renderItem={renderItem}
          renderFooter={renderFooter}
          pagination={listProps.pagination}
          actionBar={listProps.actionBar}
          selectRowsEnabled={listProps.selectRowsEnabled}
        />
      </AnyListProvider>
    </>
  );
};
